import React from 'react';
import { Drawer, Divider } from '@material-ui/core';
import useStyles from '../styles/sideMenu.styles';
import Header from './header';
import MenuList from './menu/menuList';
import ActionList from './actionList';


const SideMenu = ({ currentUser: userObject, onDrawerToggle, isMenuOpen }) => {
  const styles = useStyles();
  // console.log("SideMenu userObject", userObject); 

  return (
    <Drawer
      variant="permanent"
      className={`${isMenuOpen ? styles.drawer : styles.drawerCollpased}`}
      classes={{ paper: isMenuOpen ? styles.drawer : styles.drawerCollpased }}>
      <Header isMenuOpen={isMenuOpen} onDrawerToggle={onDrawerToggle} />
      <Divider />
      <div className={styles.actionsMenuContainer}>
        <MenuList isMenuOpen={isMenuOpen} />
        <div>
          <Divider />
          <ActionList isMenuOpen={isMenuOpen} user={userObject || {}} />
        </div>
      </div>
    </Drawer>
  );
};

export default SideMenu;
